import { render } from "./GoalDetailView.vue?vue&type=template&id=6451a073&scoped=true"
import script from "./GoalDetailView.vue?vue&type=script&lang=js"
export * from "./GoalDetailView.vue?vue&type=script&lang=js"

import "./GoalDetailView.vue?vue&type=style&index=0&id=6451a073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6451a073"]])

export default __exports__